// ContactUs.js
import React from 'react';
import './css/ContactUs.css';

const ContactUs = () => {
    return (
        <div id = "contact" className="contact-container">
            <div className="contactus-header">
                <h1>CONTACT US</h1>
                <div className="divider"></div>
            </div>

            {/* Fixed Background Image */}
            <div className="fixed-background" />

            {/* Dark Overlay */}
            <div className="background-overlay" />

            {/* Scrollable Foreground Content */}
            <div className="content-wrapper">
                <div className="main-content">
                    {/* Hero Text */}
                    <div>
                        <h1 className="hero-title">
                            Don't let a blockage
                            <span className="highlight">block your business.</span>
                        </h1>

                        <p className="hero-subtitle">
                            Call our emergency line — 24 hours, always ready.
                        </p>
                    </div>

                    {/* Phone Numbers with Icons */}
                    <div className="phone-card">
                        <div className="phone-number-container">
                            <img
                                src="../assets/icons/whatsapp.png"
                                alt="WhatsApp"
                                className="contact-icon"
                                onError={(e) => {
                                    e.target.src = "https://img.icons8.com/?size=100&id=16713&format=png&color=25D366";
                                }}
                            />
                            <a href="tel:+91-8655642421" className="phone-number">
                                +91-8655642421
                            </a>
                        </div>
                        <div className="phone-number-container">
                            <img
                                src="../assets/icons/telephone-handset.png"
                                alt="Telephone"
                                className="contact-icon"
                                onError={(e) => {
                                    e.target.src = "https://img.icons8.com/?size=100&id=Bau6VEdMrbzV&format=png&color=4285F4";
                                }}
                            />
                            <a href="tel:+91-2268727904" className="phone-number">
                                +91-2268727904
                            </a>
                        </div>
                    </div>

                    {/* Additional Contact Options */}
                    <div className="contact-grid">
                        <div className="contact-card">
                            <h3>Email Us</h3>
                            <a href="mailto:info@seatechinfra.com" target="_blank" rel="noopener noreferrer" className='email-id'>
                                info@seatechinfra.com</a>
                        </div>

                        <div className="contact-card">
                            <h3>Service Areas</h3>
                            <p>Ahmedabad, New Delhi and Mumbai, 24/7</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;